'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.OSOBA = exports.TEL = exports.EMAIL = exports.DS = exports.ADRDOR = exports.ADRDORREG = exports.ADRTRVSDL = exports.ADR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:45Z                      #

// ##############################################################

/**
 * Určuje typ kontaktu.
 */

/**
 * Adresa.
 */
var ADR = exports.ADR = 'ADR';

/**
 * Adresa trvalého pobytu/sídla.
 */
var ADRTRVSDL = exports.ADRTRVSDL = 'ADRTRVSDL';

/**
 * Doručovací adresa z registrů.
 */
var ADRDORREG = exports.ADRDORREG = 'ADRDORREG';

/**
 * Kontaktní doručovací adresa.
 */
var ADRDOR = exports.ADRDOR = 'ADRDOR';

/**
 * Datová schránka.
 */
var DS = exports.DS = 'DS';

/**
 * E-mail.
 */
var EMAIL = exports.EMAIL = 'EMAIL';

/**
 * Telefon.
 */
var TEL = exports.TEL = 'TEL';

/**
 * Kontaktní osoba.
 */
var OSOBA = exports.OSOBA = 'OSOBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ADR, ADRTRVSDL, ADRDORREG, ADRDOR, DS, EMAIL, TEL, OSOBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ADR, { caption: 'Adresa.' }), (0, _defineProperty3.default)(_params, ADRTRVSDL, { caption: 'Adresa trvalého pobytu/sídla.' }), (0, _defineProperty3.default)(_params, ADRDORREG, { caption: 'Doručovací adresa z registrů.' }), (0, _defineProperty3.default)(_params, ADRDOR, { caption: 'Kontaktní doručovací adresa.' }), (0, _defineProperty3.default)(_params, DS, { caption: 'Datová schránka.' }), (0, _defineProperty3.default)(_params, EMAIL, { caption: 'E-mail.' }), (0, _defineProperty3.default)(_params, TEL, { caption: 'Telefon.' }), (0, _defineProperty3.default)(_params, OSOBA, { caption: 'Kontaktní osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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